import type { useSobrePageModel } from '@/components/about/sobre-page/sobre-page.model'
import { ContactCtaViewModel } from '@/components/shared/contact-cta/contact-cta.view-model'

type SobrePageViewProps = ReturnType<typeof useSobrePageModel>

export function SobrePageView({
  slogan,
  infoCards,
  infoGridRef,
}: SobrePageViewProps) {
  return (
    <div className="fz-sobre-page">
      <header className="fz-sobre-page__opening">
        <h1 className="fz-sobre-page__slogan">{slogan}</h1>
      </header>
      <section className="fz-sobre-page__narrative">
        <p className="fz-sobre-page__paragraph">
          A Flora Ateliê guarda um jardim no coração da cidade — um atelier que
          cheira a haste cortada na hora. Não somos uma vitrine de flores
          prontas: cada encomenda começa numa conversa e termina numa mensagem.
        </p>
        <p className="fz-sobre-page__paragraph">
          Todos os dias, antes de abrir as portas, escolhemos peça por peça o
          que vai compor os arranjos da semana. Nada de catálogo fechado: rosas,
          orquídeas e folhagens são selecionadas pela textura, pela cor e pelo
          frescor de quem acabou de chegar — para que o buquê na sua mão tenha
          horas, não semanas, de vida.
        </p>
        <p className="fz-sobre-page__paragraph">
          Cada composição sai daqui montada à mão, uma de cada vez. Foi assim
          que nasceu a Assinatura Flora, nossa própria grife dentro da marca:
          peças autorais desenhadas como alta joalheria, do primeiro esboço ao
          laço final.
        </p>
      </section>
      <section className="fz-sobre-page__info">
        <div ref={infoGridRef} className="fz-sobre-page__info-grid">
          {infoCards.map((card) => (
            <div key={card.label} className="fz-sobre-page__info-card">
              <span className="fz-sobre-page__info-label">{card.label}</span>
              {card.lines.map((line) => (
                <span key={line} className="fz-sobre-page__info-line">
                  {line}
                </span>
              ))}
              {card.href ? (
                <a href={card.href} className="fz-sobre-page__info-link">
                  {card.linkLabel}
                </a>
              ) : null}
            </div>
          ))}
        </div>
      </section>
      <section className="fz-sobre-page__cta">
        <div className="fz-sobre-page__cta-inner">
          <h2 className="fz-sobre-page__cta-title">
            Vamos montar sua mensagem em flor?
          </h2>
          <p className="fz-sobre-page__cta-sub">
            Escreva para o ateliê e conte o que você quer dizer — a gente cuida
            do resto.
          </p>
          <ContactCtaViewModel label="Falar com o ateliê" />
        </div>
      </section>
    </div>
  )
}
